import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "react-i18next";

import { Dialog } from "@onmo/ui";

export const AppReloadPrompt = (): JSX.Element => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.warn(`SW Registered: ${registration}`);
    },
    onRegisterError(error) {
      console.error("SW registration error", error);
    },
  });

  const onClose = (): void => {
    setNeedRefresh(false);
  };

  const onRefresh = (): void => {
    setIsRefreshing(true);
    updateServiceWorker(true);
  };

  return (
    <Dialog
      mainAction={{
        text: isRefreshing ? t("refreshing") : t("refresh"),
        onClick: onRefresh,
        disabled: isRefreshing,
        loading: isRefreshing,
      }}
      secondAction={{
        text: t("close"),
        onClick: onClose,
        disabled: isRefreshing,
      }}
      open={needRefresh}
      title={t("new_version_available")}
      description={t("please_refresh_to_see_the_latest_changes")}
    />
  );
};
